import(/* webpackMode: "eager" */ "/codebuild/output/src4071359046/src/src/app/[locale]/page.tsx");
